import Module from "./Module.vue";
import ListKomplainQris from './views/ListKomplainQris.vue';
import DetailKomplainQris from './views/DetailKomplain.vue';

const requireAuth = { requireAuth: true };

const moduleRoute = {
    path: "/komplain-qris",
    component: Module,
    children: [
        {
            path: "",
            name: "komplainQris.list",
            component: ListKomplainQris,
            meta: requireAuth,
        },
        {
            path: "id/:id",
            name: "komplainQris.detail",
            component: DetailKomplainQris,
            props: true,
            meta: requireAuth,
        },
        {
            path: "refund",
            name: "komplainQris.refund",
            components: {
                default: () => {
                    return import("./views/DetailKomplain.vue");
                },
                dialog: () => {
                    return import("./components/RefundCustomer.vue");
                },
            },
        }
    ],
    
};

export default (router) => {
    router.addRoutes([moduleRoute]);
};
